import Vue from 'vue';

const storageObject = (function storageObject() {
  class Storage {
    constructor() {
      this.ACCESS_TOKEN_KEY = 'TE_STORAGE:ACCESS_TOKEN';
      this.REFRESH_TOKEN_KEY = 'TE_STORAGE:REFRESH_TOKEN';
      this.REMEBER_LOGIN_KEY = 'TE_STORAGE:REMEBER_LOGIN';

      this.sessionPrefix = 'SESSION:';
      this.removeSessionPrefix = 'REMOVE_SESSION:';
    }

    get AccessToken() {
      return sessionStorage.getItem(this.ACCESS_TOKEN_KEY)
      || localStorage.getItem(this.ACCESS_TOKEN_KEY);
    }

    get RefreshToken() {
      return sessionStorage.getItem(this.REFRESH_TOKEN_KEY)
      || localStorage.getItem(this.REFRESH_TOKEN_KEY);
    }

    get RememberStatus() {
      let status = false;
      try {
        status = JSON.parse(localStorage.getItem(this.REMEBER_LOGIN_KEY));
      } catch (e) {
        this.RemoveRememberStatusLocalStorage();
        status = false;
      }
      return status;
    }

    SetAccessTokenSessionStorage(accessToken, broadcast = false) {
      if (!broadcast) sessionStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken || '');
      localStorage.setItem(`${this.sessionPrefix}${this.ACCESS_TOKEN_KEY}`, accessToken);
      localStorage.removeItem(`${this.sessionPrefix}${this.ACCESS_TOKEN_KEY}`);
    }

    RemoveAccessTokenSessionStorage() {
      sessionStorage.removeItem(this.ACCESS_TOKEN_KEY);
      localStorage.setItem(`${this.removeSessionPrefix}${this.ACCESS_TOKEN_KEY}`, Date.now());
      localStorage.removeItem(`${this.removeSessionPrefix}${this.ACCESS_TOKEN_KEY}`);
    }

    SetAccessTokenLocalStorage(accessToken) {
      localStorage.setItem(this.ACCESS_TOKEN_KEY, accessToken || '');
    }

    RemoveAccessTokenLocalStorage() {
      localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    }

    SetRefreshTokenSessionStorage(refreshToken, broadcast = false) {
      if (!broadcast) sessionStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken || '');
      localStorage.setItem(`${this.sessionPrefix}${this.REFRESH_TOKEN_KEY}`, refreshToken);
      localStorage.removeItem(`${this.sessionPrefix}${this.REFRESH_TOKEN_KEY}`);
    }

    RemoveRefreshTokenSessionStorage() {
      sessionStorage.removeItem(this.REFRESH_TOKEN_KEY);
      localStorage.setItem(`${this.removeSessionPrefix}${this.REFRESH_TOKEN_KEY}`, Date.now());
      localStorage.removeItem(`${this.removeSessionPrefix}${this.REFRESH_TOKEN_KEY}`);
    }

    SetRefreshTokenLocalStorage(refreshToken) {
      localStorage.setItem(this.REFRESH_TOKEN_KEY, refreshToken || '');
    }

    RemoveRefreshTokenLocalStorage() {
      localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    }

    SetRememberStatusLocalStorage(remember) {
      localStorage.setItem(this.REMEBER_LOGIN_KEY, remember || false);
    }

    RemoveRememberStatusLocalStorage() {
      localStorage.removeItem(this.REMEBER_LOGIN_KEY);
    }

    TrySetStoreValue(store, key, value) {
      let processed = true;
      switch (key) {
        case this.ACCESS_TOKEN_KEY:
          store.commit('setAccessToken', value);
          break;
        case this.REFRESH_TOKEN_KEY:
          store.commit('setRefreshToken', value);
          break;
        case this.REMEBER_LOGIN_KEY:
          store.commit('setRemember', value);
          break;
        default:
          processed = false;
          break;
      }
      return processed;
    }

    MatchSessionPrefix(key) {
      return key.startsWith(this.sessionPrefix);
    }

    MatchRemoveSessionPrefix(key) {
      return key.startsWith(this.removeSessionPrefix);
    }

    PrefixProcess(key) {
      if (this.MatchSessionPrefix(key)) return key.replace(new RegExp(`^${this.sessionPrefix}`), '');
      if (this.MatchRemoveSessionPrefix(key)) return key.replace(new RegExp(`^${this.removeSessionPrefix}`), '');
      return key;
    }

    CreatePlugin() {
      const NEW_TAB_NOTIFY_KEY = 'NEW_AUTH_PAGE';
      return (store) => {
        localStorage.setItem(NEW_TAB_NOTIFY_KEY, Date.now());
        window.addEventListener('storage', (event) => {
          if (event.key === NEW_TAB_NOTIFY_KEY) {
            if ((store.getters.accessToken !== '' || store.getters.refreshToken !== '') && !store.getters.rememberLogin) {
              this.SetAccessTokenSessionStorage(store.getters.accessToken, true);
              this.SetRefreshTokenSessionStorage(store.getters.refreshToken, true);
            }
          } else if (!this.TrySetStoreValue(store, event.key, event.newValue)) {
            if ((event.newValue || null) !== null) {
              if (this.MatchSessionPrefix(event.key)) {
                const key = this.PrefixProcess(event.key);

                sessionStorage.setItem(key, event.newValue);

                this.TrySetStoreValue(store, key, event.newValue);
              } else if (this.MatchRemoveSessionPrefix(event.key)) {
                const key = this.PrefixProcess(event.key);

                sessionStorage.removeItem(key);

                this.TrySetStoreValue(store, key, '');
              }
            }
          }
        });

        store.subscribeAction((action, state) => {
          switch (action.type) {
            case 'setRememberStatus':
              if (action.payload) {
                this.SetRememberStatusLocalStorage(action.payload);
              } else {
                this.RemoveRememberStatusLocalStorage();
              }
              break;
            case 'setLoginStatus':
              if (state.authModule.isRemember) {
                this.SetAccessTokenLocalStorage(action.payload.accessToken);
                this.SetRefreshTokenLocalStorage(action.payload.refreshToken);
              } else {
                this.SetAccessTokenSessionStorage(action.payload.accessToken);
                this.SetRefreshTokenSessionStorage(action.payload.refreshToken);
              }
              break;
            case 'initialLoginStatus':
              this.RemoveAccessTokenLocalStorage();
              this.RemoveRefreshTokenLocalStorage();
              this.RemoveRememberStatusLocalStorage();

              this.RemoveAccessTokenSessionStorage();
              this.RemoveRefreshTokenSessionStorage();
              break;
            default:
              break;
          }
        });
      };
    }
  }
  return new Storage();
}());

const authModule = {
  state: {
    accessToken: '',
    refreshToken: '',
    isRemember: false,
    logoutStatus: null
  },
  getters: {
    accessToken: (state) => state.accessToken || '',
    refreshToken: (state) => state.refreshToken || '',
    rememberLogin: (state) => state.isRemember,
    payload: (state) => {
      if ((state.accessToken || '') !== '') {
        return JSON.parse(atob(state.accessToken.split('.')[1]));
      }
      return {};
    },
    userId: (state, getters) => getters.payload.sub,
    logoutStatus: (state) => state.logoutStatus
  },
  mutations: {
    setRemember(state, remember) {
      Vue.set(state, 'isRemember', remember || false);
    },
    setAccessToken(state, accessToken) {
      Vue.set(state, 'accessToken', accessToken || '');
    },
    setRefreshToken(state, refreshToken) {
      Vue.set(state, 'refreshToken', refreshToken || '');
    },
    setLogoutStatus(state, status) {
      Vue.set(state, 'logoutStatus', status || null);
    },
  },
  actions: {
    setLoginStatus({ commit }, payload) {
      commit('setAccessToken', payload.accessToken);
      commit('setRefreshToken', payload.refreshToken);
    },
    setRememberStatus({ commit }, payload) {
      commit('setRemember', payload);
    },
    initialLoginStatus({ commit }) {
      commit('setAccessToken', '');
      commit('setRefreshToken', '');
      commit('setRemember', false);
    },
    loadLoginStatus({ commit }) {
      commit('setAccessToken', storageObject.AccessToken);
      commit('setRefreshToken', storageObject.RefreshToken);
      commit('setRemember', storageObject.RememberStatus);
    }
  }
};

export default {
  module: authModule,
  plugin: storageObject.CreatePlugin()
};
